import { AxiosError } from 'axios';
import { CredentialType } from 'web-library/models/AccountManagementConfiguration';

import { LookupListApiItem } from '../../api/user/model';
import { POST_CREATE_CANDIDATE_NEW_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";
import {Dayjs} from "dayjs";

// =============================================================================
// Request Model
// =============================================================================

export interface UserProfileData {
  name: string | null;
  email: string | null;
  countryCode: number | null;
  contactNumber: string | null;
  dateOfBirth?: string | null;
  enabled: boolean | null;
}

export interface CreateCandidateRequestData {
  user: UserProfileData;
  candidateType: string | null;
  candidateId: string | null;
  userIdType: string | null;
  organisationId: number | null;
  organisationUuid?: string;
  hanyuPinyinName: string | null;
  chineseName: string | null;
  gender: string | null;
  dateOfBirth?: string | null;
  race: string | null;
  secondRace: string | null;
  nationality: string | null;
  nationalityIssueDate?: string | null;
  citizenship: string | null;
  localAddressBlockNumber: string | null;
  localAddressUnitNumber: string | null;
  localAddressFloorNumber: string | null;
  localAddressStreetName: string | null;
  localAddressBuildingName: string | null;
  localAddressPostalCode: string | null;
  isLocalAddressPreferred: boolean | null;
  isMobileNumberPreferred: boolean | null;
  prStatus: string | null;
  occupation?: LookupListApiItem;
  foreignAddress1: string | null;
  foreignAddress2: string | null;
  foreignAddress3: string | null;
  nextOfKinName: string | null;
  nextOfKinRelationship: string | null;
  iexamsId: string | null;
  telephoneNumberCountryCode: number | 0 | null;
  telephoneNumber: string | null;
  nextOfKinContactNumberCountryCode: number | null;
  nextOfKinContactNumber: string | null;
  credentialType: CredentialType | null;
  activationRequired: boolean | null;
}

// =============================================================================
// Mutation
// =============================================================================

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateCandidateNew = ({ onSuccess, onError }: Input = {}) => {
  const postCreateCandidateNew = async (reqBody: CreateCandidateRequestData): Promise<void> => {
    await axiosClient.post<void>(POST_CREATE_CANDIDATE_NEW_URL, reqBody, { timeout: 30000 });
  };

  return useCustomMutation(
    postCreateCandidateNew,
    {
      onSuccess,
      onError,
    },
    false
  );
};
